"use client";

import { useQuery } from "@tanstack/react-query";
import { useAccessToken, useTenantData } from "@/hooks/shared";
import { getMakeupSession } from "@/lib/services/makeupService";
import { QueryKeys } from "@/lib/types";

export function useMakeupSessionById(
  makeupId: string | null,
  enabled = true,
  refetchInterval?: number | false,
) {
  const accessToken = useAccessToken();
  const { tenantId } = useTenantData();

  return useQuery({
    queryKey: [QueryKeys.MakeupSessions, "by-id", tenantId, makeupId],
    enabled:
      enabled &&
      makeupId != null &&
      makeupId !== "" &&
      !!accessToken &&
      tenantId != null,
    queryFn: async () => {
      if (!accessToken || makeupId == null) {
        throw new Error("Missing session or makeup id");
      }
      return getMakeupSession(accessToken, makeupId);
    },
    staleTime: 0,
    refetchOnMount: "always",
    refetchInterval,
  });
}
